import { render, staticRenderFns } from "./VatId.vue?vue&type=template&id=40f8d862"
import script from "./VatId.vue?vue&type=script&lang=js"
export * from "./VatId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports